// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineOutlinedSvg from "@ant-design/icons-svg/es/asn/LineOutlined";
import AntdIcon from '../components/AntdIcon';

var LineOutlined = function LineOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineOutlinedSvg
  }));
};

LineOutlined.displayName = 'LineOutlined';
export default React.forwardRef(LineOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LineOutlined.js
// module id = 1419
// module chunks = 0